import React, { useEffect, useState } from 'react'
import assetService from '../Services/assetService';
import { useParams } from 'react-router-dom';
import Article from '../Components/ArticlesList/Article/Article';
import CostaMain from '../Components/CostaMain/CostaMain';
import { Container } from 'react-bootstrap';
import { FadeLoader } from 'react-spinners';

const SingleArticle = () => {
    const [isLoading, setIsLoading] = useState([]);
    const [content, setContent] = useState([]);

    const { assetId } = useParams();
    const { channelGuid } = useParams();

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            try {
                let data;
                data = await assetService.getAssetDetails(channelGuid, assetId);

                setContent(data);
            } catch (error) {
                console.error("Errore nel recupero dell'articolo:", error);
            }
            setIsLoading(false);
        })();
    }, []);

    return (
        <CostaMain>
            <Container fluid className='panel panel-body'>
                {!isLoading ? <Article articleContent={content} /> : (
                    <Container fluid style={{ "height": "120px" }} className="d-flex justify-content-center">
                        <FadeLoader
                            color="#1a6fb8"
                            height={25}
                            loading
                            margin={15}
                            radius={2}
                            speedMultiplier={1.5}
                            width={3}
                        />
                    </Container>
                )}
            </Container>
        </CostaMain>
    )
}

export default SingleArticle